import { Component } from '@angular/core';
import { BottomLinksComponent } from "../../index/bottom-links/bottom-links.component";

@Component({
  selector: 'app-footer',
  imports: [BottomLinksComponent],
  template: `

    <app-bottom-links></app-bottom-links>

    <footer class="bg-background text-backgroundContrast text-center p-4">
      <p>&copy; 2025 Sportilink. All rights reserved.</p>
      <p class="text-sm mt-1">
        Made by
        <a
          href="https://digilifesoftware.com"
          target="_blank"
          rel="noopener"
          class="font-semibold underline"
          >Digilife Software</a
        >
      </p>
    </footer>
  `,
  styles: ``,
})
export class FooterComponent {}
